import React, { useEffect } from "react";
import { useParams } from "react-router";
import { getTourServiceDetailByURL } from "./services/home.services";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearTourServiceDetails } from "./homeSlice";
import { decodeHtml } from "../../_helpers/tourUtils";
import Loading from "../../components/spinner/Loading";

const WeekendServiceDetail = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const ServiceURL = params?.ServiceURL;

  const TourServiceDetails = useAppSelector(
    (state) => state.home.TourServiceDetails
  );
  const loading = useAppSelector((state) => state.home.loading);

  useEffect(() => {
    if (ServiceURL) {
      dispatch(getTourServiceDetailByURL(ServiceURL));
    }
    return () => {
      dispatch(clearTourServiceDetails());
    };
  }, [ServiceURL]);

  return (
    <>
      <Loading loading={loading} />
      <div className="tour-service-detail">
        <div className="container">
          <div className="tour-service-pic">
            <img
              src={TourServiceDetails?.Image}
              alt={TourServiceDetails?.Title || "Banner Image"}
            />
          </div>
          <h3 className="mt-4">{TourServiceDetails?.Title}</h3>
          {TourServiceDetails?.LongDescription && (
            <div
              dangerouslySetInnerHTML={{
                __html: decodeHtml(TourServiceDetails?.LongDescription),
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default WeekendServiceDetail;
